import React, { useEffect, useState } from 'react';
import { adminAPI } from '../../services/api';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
    // Auto-refresh every 30 seconds
    const interval = setInterval(loadStats, 30000);
    return () => clearInterval(interval);
  }, []);

  const loadStats = async () => {
    try {
      const data = await adminAPI.getDashboardStats();
      setStats(data);
    } catch (error) {
      console.error('Failed to load dashboard stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading-spinner">Loading...</div>;
  }

  return (
    <div className="admin-dashboard">
      {/* Stats Cards */}
      <div className="stats-grid">
        {/* Total Orders */}
        <div className="stat-card">
          <div className="stat-icon orders">📦</div>
          <div className="stat-info">
            <h3>Total Orders</h3>
            <p className="stat-value">{stats?.totalOrders || 0}</p>
          </div>
        </div>

        {/* Total Revenue */}
        <div className="stat-card">
          <div className="stat-icon revenue">💰</div>
          <div className="stat-info">
            <h3>Total Revenue</h3>
            <p className="stat-value">৳{stats?.totalRevenue?.toLocaleString() || 0}</p>
          </div>
        </div>

        {/* Total Customers */}
        <div className="stat-card">
          <div className="stat-icon customers">👥</div>
          <div className="stat-info">
            <h3>Total Customers</h3>
            <p className="stat-value">{stats?.totalCustomers || 0}</p>
          </div>
        </div>

        {/* Pending Orders */}
        <div className="stat-card warning">
          <div className="stat-icon pending">⏳</div>
          <div className="stat-info">
            <h3>Pending Orders</h3>
            <p className="stat-value">{stats?.pendingOrders || 0}</p>
          </div>
        </div>

        {/* Processing Orders */}
        <div className="stat-card info">
          <div className="stat-icon processing">⚙️</div>
          <div className="stat-info">
            <h3>Processing Orders</h3>
            <p className="stat-value">{stats?.processingOrders || 0}</p>
          </div>
        </div>

        {/* Completed Orders */}
        <div className="stat-card success">
          <div className="stat-icon completed">✅</div>
          <div className="stat-info">
            <h3>Completed Orders</h3>
            <p className="stat-value">{stats?.completedOrders || 0}</p>
          </div>
        </div>

        {/* Today's Orders */}
        <div className="stat-card highlight">
          <div className="stat-icon today">📅</div>
          <div className="stat-info">
            <h3>Today's Orders</h3>
            <p className="stat-value">{stats?.todayOrders || 0}</p>
          </div>
        </div>

        {/* Today's Revenue */}
        <div className="stat-card highlight">
          <div className="stat-icon today-revenue">💵</div>
          <div className="stat-info">
            <h3>Today's Revenue</h3>
            <p className="stat-value">৳{stats?.todayRevenue?.toLocaleString() || 0}</p>
          </div>
        </div>

        {/* Total Products */}
        <div className="stat-card">
          <div className="stat-icon products">🛍️</div>
          <div className="stat-info">
            <h3>Total Products</h3>
            <p className="stat-value">{stats?.totalProducts || 0}</p>
          </div>
        </div>

        {/* Out of Stock */}
        <div className="stat-card danger">
          <div className="stat-icon out-stock">🚫</div>
          <div className="stat-info">
            <h3>Out of Stock</h3>
            <p className="stat-value">{stats?.outOfStock || 0}</p>
          </div>
        </div>

        {/* Low Stock */}
        <div className="stat-card warning">
          <div className="stat-icon low-stock">⚠️</div>
          <div className="stat-info">
            <h3>Low Stock (≤10)</h3>
            <p className="stat-value">{stats?.lowStock || 0}</p>
          </div>
        </div>

        {/* Active Products */}
        <div className="stat-card success">
          <div className="stat-icon active-products">✨</div>
          <div className="stat-info">
            <h3>Active Products</h3>
            <p className="stat-value">{stats?.activeProducts || 0}</p>
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="dashboard-section">
        <h3 className="section-title">Recent Orders</h3>
        <div className="recent-orders-table">
          <table>
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Customer</th>
                <th>Date</th>
                <th>Status</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {stats?.recentOrders?.map((order: any) => (
                <tr key={order.id}>
                  <td>#{order.id}</td>
                  <td>{order.customer}</td>
                  <td>{order.date}</td>
                  <td>
                    <span className={`status-badge ${order.status.toLowerCase()}`}>
                      {order.status}
                    </span>
                  </td>
                  <td>৳{order.total.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
